import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton QueryClient exported so non-React code (api interceptors, logout
 * handler in DashboardLayout) can call queryClient.clear() on auth state changes.
 *
 * Import this instead of using useQueryClient() wherever you need it outside of
 * a React component tree.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 2,
    },
  },
});
